import { render, staticRenderFns } from "./GrayRouteLog.vue?vue&type=template&id=fa8ca97a&scoped=true"
import script from "./GrayRouteLog.vue?vue&type=script&lang=js"
export * from "./GrayRouteLog.vue?vue&type=script&lang=js"
import style0 from "./GrayRouteLog.vue?vue&type=style&index=0&id=fa8ca97a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8ca97a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa8ca97a')) {
      api.createRecord('fa8ca97a', component.options)
    } else {
      api.reload('fa8ca97a', component.options)
    }
    module.hot.accept("./GrayRouteLog.vue?vue&type=template&id=fa8ca97a&scoped=true", function () {
      api.rerender('fa8ca97a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cfg/GrayRouteLog.vue"
export default component.exports